export const DASHBOARDS_AVAILABILITY_KEY = 'dashboardsAvailability';
export const ASK_AGORA_REPORTS_KEY = 'askAgoraReports';
export const ASK_AGORA_DATASETS_KEY = 'askAgoraDatasets';
export const ASK_AGORA_KEY = 'askAgora';
export const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;
export const THREE_MONTHS = 3 * 30 * 24 * 60 * 60 * 1000;
